import { createSlice } from "@reduxjs/toolkit";
import { GetAllTemplates } from "store/middlewares/dataManagement/messageTemplate";

// isDeleteMeFulFilled
export const templatesSlice = createSlice({
  name: "templates",
  initialState: {
    templatesLoading: true,
    templates: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllTemplates.pending, (state) => {
        state.templates =
          state.templates?.result?.length > 0 ? state.templates : null;
      })
      .addCase(GetAllTemplates.fulfilled, (state, action) => {
        state.templatesLoading = false;
        state.templates = action.payload.response;
      })
      .addCase(GetAllTemplates.rejected, (state) => {
        state.templatesLoading = false;
        state.templates = null;
      });
  },
});

export default templatesSlice.reducer;
